
import { defineComponent, ref, watch } from "vue";
import moment from "moment";

export default defineComponent({
  name: "investment-history",
  props: {
    investments: Array,
    currencyCode: String,
  },
  components: {},
  setup(props) {
    const currencyCodeTemp = ref<string>(props.currencyCode as string);
    const investmentsTemp = ref<Array<Record<string, unknown>>>(
      props.investments as Array<Record<string, unknown>>
    );
    watch(
      () => props.investments,
      (value) =>
        (investmentsTemp.value = value as Array<Record<string, unknown>>)
    );
    const formatDate = (date) => {
      return moment(date).format("YYYY-MM-DD");
    };
    return {
      formatDate,
      currencyCodeTemp,
      investmentsTemp,
    };
  },
});
